import { loadWidgetInitialContent } from '@/components/chatbot/chatbotWidgetContentController';

// the below logic interacts with the JS on the UBS.  It is for a better user experience.
function geolocationSucceeded() {
  // we don't want to do anything if geolocate succeeds because the page will be reloaded
  // I'm adding this console.log here to generate a new version of this file in the cdn
  console.log('Browser geolocation succeeded');
}

function geolocationRejected() {
  loadWidgetInitialContent();
}

if (window.UbsGeolocationPending === true) {
  let options = {
    enableHighAccuracy: false,
    timeout: 10000,
    maximumAge: 0,
  };
  navigator.geolocation.watchPosition(
    geolocationSucceeded,
    geolocationRejected,
    options,
  );
} else {
  loadWidgetInitialContent();
}
